import React from 'react';

import { MenuItem } from '../../components/Menuitem/MenuItem';
import { SubHeading } from '../../components/SubHeading/SubHeading';
import { categories, packagesFAQs, wines } from '../../constants/data';
import { Gallery } from '../Gallery/Gallery';
import { AwardCard } from '../Laurels/Laurels';

import { BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs';

import { Grid } from '@mui/material';
import { useState } from 'react';
import { question } from '../../constants/images';

import './Packages.css';



export const PackagesV2 = () =>(

    <div>
      <Categories />
      <PackagesList />
      <BookingFAQs />
      <Gallery />
    </div>
  )

  const Categories = () => {
  const scrollRef = React.useRef(null);

  const scroll = (direction) => {
    const { current } = scrollRef;

    if (direction === 'left') {
      current.scrollLeft -= 300;
    } else {
      current.scrollLeft += 300;
    }
  };

  return (
    <div className="app__gallery flex__center">
      <div className="app__gallery-content">
        <SubHeading title="DGA Package Categories" />
        <h1 className="headtext__cormorant">Packages Categories</h1>
        <p className="p__opensans" style={{ color: '#AAAAAA', marginTop: '2rem' }}>There are different categories of tour and travel packages. Click Card to filter. </p>
      </div>
      
      <div className="app__services-images">
        <div className="app__services-images_container" ref={scrollRef}>
          {categories.map((s, index) => (
            <div className="app__services-images_card flex__center" key={`services_image-${index + 1}`}>
              <img src={s.image} alt="services_image" />
              <div className="services__image-icon" >
                <p>{s.title}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="app__services-images_arrows">
          <BsArrowLeftShort className="services__arrow-icon" onClick={() => scroll('left')} />
          <BsArrowRightShort className="services__arrow-icon" onClick={() => scroll('right')} />
        </div>
      </div>
    </div>
  );
};


  const PackagesList = () => {

    const [max, setmax] = useState(6)
    return (
  <div className="app__specialMenu flex__center section__padding" id="menu">
    <div className="app__specialMenu-title">
      <SubHeading title="Packages your style" />
      <h1 className="headtext__cormorant">Available Packages</h1>
    </div>

    <Grid container spacing={2} alignItems="stretch" className="app__specialMenu-menu">
          {wines.map((wine, index) => (
            <Grid  item sm={6} lg={4} >
              <MenuItem key={wine.title + index} title={wine.title} price={wine.price} tags={wine.tags} image={wine.image} />
            </Grid>
          )).slice(0, max)}
    </Grid>

    <div style={{ marginTop: 15 }}>
      {wines.length > max && <button type="button" className="custom__button" onClick={()=>setmax(max+4)}>Load More</button>}
      {wines.length < max && <button type="button" className="custom__button" onClick={()=>setmax(max-4)}>Show Less</button>}
    </div>
  </div>
);
  }


  export const BookingFAQs = () => (
    <div className="app__bg app__wrapper section__padding" id="awards">
      <div className="app__wrapper_info">
        <SubHeading title="Booking Packages FAQs" />
        <h1 className="headtext__cormorant">FAQs</h1>
  
        <div className="app__laurels_awards">
          {packagesFAQs.map((award) => <AwardCard award={award} key={award.title} />)}
        </div>
      </div>
  
      <div className="app__wrapper_img">
        <img src={question} alt="laurels_img" />
      </div>
    </div>
  );
